import { combineReducers } from "@reduxjs/toolkit";
import smarthopWallet from "./smarthopWalletSlice";

const toolsReducers = combineReducers({
	smarthopWallet,
});

export default toolsReducers;
